exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiFieldSelectorCheckBox__row___1AYI_ {\n  height: 100%; }\n\n.multiFieldSelectorCheckBox__checkboxWrapper___1a8Mh {\n  width: 100%; }\n\n.multiFieldSelectorCheckBox__title___oIose {\n  font-size: 16px;\n  font-weight: 600;\n  color: #000;\n  margin: 20px 0 10px; }\n\n.multiFieldSelectorCheckBox__singleCheckbox___5L3Tu {\n  width: 100%; }\n  @media (max-width: 768px) {\n    .multiFieldSelectorCheckBox__singleCheckbox___5L3Tu {\n      text-align: start; } }\n\n.multiFieldSelectorCheckBox__alignCheckbox___3fkEK {\n  display: flex;\n  align-items: center; }\n\n.multiFieldSelectorCheckBox__infoIcon___2ynuV {\n  margin: 0 8px; }\n", ""]);

// exports
exports.locals = {
	"row": "multiFieldSelectorCheckBox__row___1AYI_",
	"checkboxWrapper": "multiFieldSelectorCheckBox__checkboxWrapper___1a8Mh",
	"title": "multiFieldSelectorCheckBox__title___oIose",
	"singleCheckbox": "multiFieldSelectorCheckBox__singleCheckbox___5L3Tu",
	"alignCheckbox": "multiFieldSelectorCheckBox__alignCheckbox___3fkEK",
	"infoIcon": "multiFieldSelectorCheckBox__infoIcon___2ynuV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiFieldSelectorCheckBox/multiFieldSelectorCheckBox.scss
// module id = 4200
// module chunks = 6